import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import "../styles/ContactUs.css";

function ContactUsPage() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isZh = pathname.startsWith('/hk');

  const items = isZh
    ? [
        { label: t('contact.general'), email: 'cs@activikid.hk' },
        { label: t('contact.media'), email: 'media@activikid.hk' },
        { label: t('contact.partnership'), email: 'marketing@activikid.hk' },
        { label: t('contact.business'), email: 'business@activikid.hk' },
      ]
    : [
        { label: t('contact.general'), email: 'cs@activikid.hk' },
        { label: t('contact.media'), email: 'media@activikid.hk' },
        { label: t('contact.partnership'), email: 'marketing@activikid.hk' },
        { label: t('contact.business'), email: 'business@activikid.hk' },
      ];

  return (
    <>
      <Navbar />
      <div className="contact-us-page">
        <h1 className="contact-us-title">{t('contact.title')}</h1>
        <div className="contact-grid">
          {items.map((item) => (
            <div className="contact-card" key={item.label + item.email}>
              <h2 className="contact-card-title">{item.label}</h2>
              <p className="contact-card-email">
                <span className="contact-card-label">{t('contact.email_label')}: </span>
                <a href={`mailto:${item.email}`}>{item.email}</a>
              </p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ContactUsPage;
